import {
    CO_GET_DELIVEREDON_LISTING,
    CO_GET_DELIVEREDON_LISTING_SUCCESS,
    CO_GET_DELIVEREDON_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    deliveredOn: null,
  }
  
  const coDeliveredOn = (state = initialState, action) => {
    switch (action.type) {
      case CO_GET_DELIVEREDON_LISTING:
        state = {
          ...state,
          loading: true,
          deliveredOn: action.payload,
        }
        break
      case CO_GET_DELIVEREDON_LISTING_SUCCESS:
        state = { ...state, loading: false, deliveredOn: action.payload }
        break
      case CO_GET_DELIVEREDON_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default coDeliveredOn
  